export enum StationAdditionFormFields {
  defaultPrice = "defaultPrice",
  prices = "prices",
  excludeEmptyStations = "excludeEmptyStations",
  counterIsPerArea = "counterIsPerArea",
}
